<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Dodaj nowego Administratora</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                <v-form ref="add" v-model="valid">
                  <v-text-field
                    :error-messages="firstnameErrors"
                    v-model="firstname"
                    label="Imię"
                    class="mb-5"
                    required
                    @input="$v.firstname.$touch()"
                    @blur="$v.firstname.$touch()"
                  ></v-text-field>
                  <v-text-field
                    :error-messages="lastnameErrors"
                    v-model="lastname"
                    label="Nazwisko"
                    class="mb-5"
                    required
                    @input="$v.lastname.$touch()"
                    @blur="$v.lastname.$touch()"
                  ></v-text-field>
                  <v-text-field
                    :error-messages="emailErrors"
                    v-model="email"
                    label="Email"
                    type="email"
                    class="mb-5"
                    required
                    @input="$v.email.$touch()"
                    @blur="$v.email.$touch()"
                  ></v-text-field>
                  <v-alert dense text type="error" v-if="error">{{
                    errorMessages
                  }}</v-alert>
                  <p class="mt-10">Status:</p>
                  <v-radio-group v-model="active" row>
                    <v-radio
                      name="active"
                      label="Aktywny"
                      :value="true"
                    ></v-radio>
                    <v-radio
                      name="active"
                      label="Nieaktywny"
                      :value="false"
                    ></v-radio>
                  </v-radio-group>
                  <p>Rola:</p>
                  <v-radio-group v-model="role" row>
                    <v-radio name="role" label="Admin" :value="false"></v-radio>
                    <v-radio
                      name="role"
                      label="Super Admin"
                      :value="true"
                    ></v-radio>
                  </v-radio-group>
                </v-form>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error darken-1" @click="close()">
            Zamknij
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="success darken-1"
            @click="add()"
            :disabled="$v.$invalid"
          >
            Utwórz
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axiosConf from "../axios-conf";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";

export default {
  props: {
    openAdd: Boolean
  },
  mixins: [validationMixin],
  data() {
    return {
      dialog: false,
      valid: false,
      firstname: null,
      lastname: null,
      email: null,
      active: true,
      role: false,
      error: false,
      errorMessages: null
    };
  },
  watch: {
    openAdd(newVal) {
      this.dialog = newVal;
    }
  },
  methods: {
    close() {
      this.dialog = false;
      this.$emit("closeAdd", "close");
      this.clear();
    },
    add() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        const admin = {
          email: this.email,
          firstname: this.firstname,
          lastname: this.lastname,
          active: this.active,
          role: this.role
        };
        axiosConf
          .post(`administrator/create.json`, admin, {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("loggedIn")}`
            }
          })
          .then(response => {
            if (response.status === 200) {
              this.$emit("closeAdd", true);
            } else {
              this.$emit("closeAdd", false);
            }
            this.clear();
          })
          .catch(err => {
            const status = JSON.parse(err.request.response).status;
            if (!status) {
              this.error = true;
              this.errorMessages = "Podany adres e-mail został już użyty.";
            }
          });
      }
    },
    clear() {
      this.$v.$reset();
      this.email = "";
      this.firstname = "";
      this.lastname = "";
      this.error = false;
    }
  },
  validations: {
    firstname: {
      required
    },
    lastname: {
      required
    },
    email: {
      required,
      email
    }
  },
  computed: {
    firstnameErrors() {
      const errors = [];
      if (!this.$v.firstname.$dirty) return errors;
      !this.$v.firstname.required && errors.push("Pole jest wymagane.");
      return errors;
    },
    lastnameErrors() {
      const errors = [];
      if (!this.$v.lastname.$dirty) return errors;
      !this.$v.lastname.required && errors.push("Pole jest wymagane.");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push("Niepoprawny adres e-mail");
      !this.$v.email.required && errors.push("E-mail jest wymagany");
      return errors;
    }
  }
};
</script>
